import { connect } from 'react-redux';
import { closeInCallModal } from 'actions/InCallModal';
import RemoveFromMeetingModal from 'components/RemoveFromMeetingModal';
import { callActions, moderatorActions } from '@lifesize/nucleus';

const mapActionCreators = (dispatch, ownProps) => {
  return {
    onCancelClicked: () => dispatch(closeInCallModal()),
    onRemoveClicked: (participant) => {
      dispatch(closeInCallModal());
      if (ownProps.isRemoteModerator) {
        dispatch(moderatorActions.ejectParticipant(participant.participantId));
      } else {
        dispatch(callActions.kick(participant));
      }
    }
  };
};

export default connect(null, mapActionCreators)(RemoveFromMeetingModal);
